import { ExonerationZoneResult } from '@models/exoneration-zone-result';

export type ExonerationZone = {
  key: keyof ExonerationZoneResult;
  zone: string;
  zoneReference: string[];
  period: string[];
  source: string[];
  sites: string[];
};
export const EXONERATION_ZONES: ExonerationZone[] = [
  {
    key: 'zafr',
    zone: '(ZAFR) Zone d’Aide à Finalité Régionale',
    zoneReference: ['Décret 2023-1286 du 26/12/2023'],
    period: ['2022 - 2027'],
    source: ['https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000048679603'],
    sites: ['https://www.observatoire-des-territoires.gouv.fr/afr-aide-finalite-regionale-2022-2027-communes-eligibles']
  },
  {
    key: 'qppv',
    zone: '(QPPV) Quartier prioritaire de la Politique de la Ville',
    zoneReference: [
      'Département métropolitains : Décret 2023-1314 du 28/12/2023',
      'Département outre-mer : Décret 2014-1751 du 30/12/2014'
    ],
    period: [
      'Département métropolitains : À partir du 01/01/2024',
      'Département outre-mer : Actualisation prévue au 01/01/2025'
    ],
    source: [
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000048707389',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000030007947'
    ],
    sites: ['https://sig.ville.gouv.fr']
  },
  {
    key: 'zfu',
    zone: '(ZFU-TE) Zone Franche Urbaine - Territoire Entrepreneur',
    zoneReference: [
      '1ère génération : Annexe 1 de la Loi 96-987 du 14/11/1996',
      '2nde génération : Annexe 1 bis de loi du 14/11/1996',
      '3ème génération : Décret 2006-930 du 28/07/2006'
    ],
    period: [],
    source: [
      'https://www.legifrance.gouv.fr/loda/article_lc/LEGIARTI000030061325',
      'https://www.legifrance.gouv.fr/loda/article_lc/LEGIARTI000030061325',
      'https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000790611'
    ],
    sites: ['https://sig.ville.gouv.fr/atlas/ZFU']
  },
  {
    key: 'zrr',
    zone: '(ZRR) Zone de Revitalisation Rurale',
    zoneReference: ['Arrêtés ARCR1705918A du 16/03/2017', 'TERR1801781A du 22/02/2018', 'Arrêté du 19/06/2024'],
    period: [`Jusqu'au 30/06/2024`],
    source: [
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000034298773',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000036755974',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000049746830'
    ],
    sites: [
      'https://www.observatoire-des-territoires.gouv.fr/zrr-zone-de-revitalisation-rurale-0',
      'https://www.service-public.fr/simulateur/calcul/zonageFranceRuralitesRevitalisation'
    ]
  },
  {
    key: 'zfrr',
    zone: '(ZFRR et ZFRR “plus”) Zone France Ruralité Revitalisation',
    zoneReference: ['Arrêté du 19/06/2024'],
    period: ['A compter du 01/07/2024'],
    source: ['https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000049746820'],
    sites: [
      'https://www.observatoire-des-territoires.gouv.fr/frr-france-ruralites-revitalisation',
      'https://www.service-public.fr/simulateur/calcul/zonageFranceRuralitesRevitalisation'
    ]
  },
  {
    key: 'ber',
    zone: '(BER) Bassin d’Emploi à Redynamiser',
    zoneReference: ['Décret 2007-228 du 20 février 2007'],
    period: ["Jusqu'au 31/12/2027"],
    source: ['https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000465967'],
    sites: []
  },
  {
    key: 'zrd',
    zone: '(ZRD) Zone de Restructuration de la Défense',
    zoneReference: [
      'Arrêté EATM0918160A du 1er septembre 2009',
      'Arrêté ETLC1237090A du 1er février 2013',
      'Arrêté ETLR1501628A du 28 mai 2015',
      'Arrêté ETLR1528679A du 8 février 2016',
      'Arrêté ARCR1622070A du 2 novembre 2016',
      'Arrêté TERB2121679A du 20 août 2021'
    ],
    period: [],
    source: [
      'https://www.legifrance.gouv.fr/loda/id/JORFTEXT000021042550',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000027063746',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000030649409',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000032036947',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000033367856',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000044019343'
    ],
    sites: []
  },
  {
    key: 'bud',
    zone: '(BUD) Bassin Urbain à Dynamiser',
    zoneReference: ['Arrêté TERR1802127A du 14 février 2018', 'Arrêté COTV1902479A du 11 avril 2019'],
    period: [],
    source: [
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000036629898',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000038436169'
    ],
    sites: []
  },
  {
    key: 'zdp',
    zone: '(ZDP) Zone de Développement Prioritaire',
    zoneReference: ['Arrêté COTV1903182A du 11 mars 2019'],
    period: [],
    source: ['https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000038235349'],
    sites: []
  },
  {
    key: 'zrcv',
    zone: '(ZRCV) Zone de Revitalisation des Centres-Villes',
    zoneReference: [
      'Arrêté TERB2021924A du 31 décembre 2020',
      'Arrêté TERB2132846A du 3 décembre 2021',
      'Arrêté TREB2232777A du 14 décembre 2022',
      'Arrêté TREB2332748A du 22 décembre 2023'
    ],
    period: [],
    source: [
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000042865778',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000044591655',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000046793590',
      'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000048669552'
    ],
    sites: []
  },
  {
    key: 'zorcomir',
    zone: '(ZORCOMIR) Zone de Revitalisation des Commerces en Milieu Rural',
    zoneReference: ['Arrêté TERB2006893A du 16 octobre 2020'],
    period: ["Jusqu'au 30/06/2024"],
    source: ['https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000042570267'],
    sites: [
      'https://www.observatoire-des-territoires.gouv.fr/classement-des-communes-en-zone-de-revitalisation-des-commerces-en-milieu-rural-zorcomir'
    ]
  }
];
